// takes an array and an index, increases the index by 1 or gets the first index if at the end of the array
module.exports = function(direction, array, currentIndex) {
    if (direction == "next") {
        return (currentIndex == array.length - 1) ? 0 : ++currentIndex;
    } else if (direction == "prev") {
        return (currentIndex == 0) ? array.length - 1 : --currentIndex;
    }
    return currentIndex;
};